/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SellCardRequest as AgentApiContractSellCardRequest } from '../../models/AgentApi/Contract/sell-card-request';
import { SellCardResponse as AgentApiContractSellCardResponse } from '../../models/AgentApi/Contract/sell-card-response';

export interface ApiAgentSellCardPost$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiContractSellCardRequest
}

export function apiAgentSellCardPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentSellCardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellCardResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentSellCardPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractSellCardResponse>;
    })
  );
}

apiAgentSellCardPost$Plain.PATH = '/api/Agent/SellCard';
